import { createFileRoute } from '@tanstack/react-router'
import { ModuleGate } from '@/components/module-gate'

export const Route = createFileRoute('/_authed/ams')({
  component: () => (
    <ModuleGate moduleKey="ams">
      <AmsContracts />
    </ModuleGate>
  ),
})

function AmsContracts() {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold">AMS Contracts</h2>
      <p className="mt-2 text-muted-foreground">Coming in Phase 1d.</p>
    </div>
  )
}
